import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  readonly dataStr = new Subject<string>();
  readonly dataClass = new Subject<boolean>();

  setClass(data: boolean): void {
    this.dataClass.next(data);
  }

  sendMessage(data: string): void {
    this.dataStr.next(data);
  }
}
